import { supabase } from '@/integrations/supabase/client';

type HomepageAuthUser = {
  id: string;
};

export const GOOGLE_AUTH_CREDIT_CHECK_KEY = 'bookstera_google_auth_credit_check';

export const getUserCreditBalance = async (user: HomepageAuthUser) => {
  const { data, error } = await supabase.functions.invoke('get-user-credits', {
    body: { userId: user.id },
  });

  if (error) {
    throw error;
  }

  return data?.balance || 0;
};

export const getHomepageAuthDestination = async (knownUser?: HomepageAuthUser | null) => {
  let user = knownUser;

  if (!user) {
    const {
      data: { user: currentUser },
    } = await supabase.auth.getUser();

    user = currentUser;
  }

  if (!user) {
    return '/pricing';
  }

  try {
    const balance = await getUserCreditBalance(user);
    return balance > 0 ? '/create-book' : '/pricing';
  } catch (error) {
    console.error('Error checking credits for homepage redirect:', error);
    return '/pricing';
  }
};
